import { styled as r, Box as i } from "@mui/material";
import e from "./MuiLoading.js";
import { jsx as o } from "react/jsx-runtime";
const a = r(i)`
  width: 100%;
  text-align: center;
  padding: 30px 0px;
`, m = (t) => {
  const {
    className: n
  } = t;
  return /* @__PURE__ */ o(a, {
    className: n,
    children: /* @__PURE__ */ o(e, {
      loading: !0
    })
  });
};
export {
  m as default
};
//# sourceMappingURL=ApeironLoadingNow.js.map
